import {ConfigState, ConfigActions} from '@common/types/stores/configStore.types';
import {createCustomStore} from '@common/helpers/store/storeHelper';

export const initialState: ConfigState = {
  endpoints: null,
  isLoading: false,
  upload: null
};

const useConfigStore = createCustomStore<ConfigState & ConfigActions>('config', set => ({
  ...initialState,

  loadConfig: async () => {
    set(
      state => {
        state.endpoints = initialState.endpoints;
        state.isLoading = true;
        state.upload = initialState.upload;
      },
      undefined,
      'loadConfig/pending'
    );
    const config = await (await fetch('/config')).json();
    const {endpoints, upload} = config;
    set(
      state => {
        state.endpoints = endpoints;
        state.isLoading = false;
        state.upload = upload;
      },
      undefined,
      'loadConfig/fulfilled'
    );
  }
}));

export const getEndPoints = () => {
  const endpoints = useConfigStore.getState().endpoints;
  if (!endpoints) {
    throw new Error('Endpoints not found');
  }

  return endpoints;
};

export const getUpload = () => {
  const upload = useConfigStore.getState().upload;
  if (!upload) {
    throw new Error('Upload not found');
  }

  return upload;
};

export default useConfigStore;
